import React from "react";
import PropTypes from "prop-types";
import TextField from "material-ui/TextField";
import {FieldTitle} from "admin-on-rest";

const DisabledInput = ({
  input: {value},
  label,
  resource,
  source,
  elStyle,
  options,
  customInputStyle,
  customUnderlineDisabledStyle,
  fullWidth
}) => (
  <TextField
    value={value}
    hintText={<FieldTitle label={label} source={source} resource={resource} />}
    style={elStyle}
    disabled
    fullWidth={fullWidth}
    underlineDisabledStyle={customUnderlineDisabledStyle}
    inputStyle={customInputStyle}
    {...options}
  />
);

DisabledInput.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  addField: PropTypes.bool.isRequired
};

DisabledInput.defaultProps = {
  addField: true
};

export default DisabledInput;



// WEBPACK FOOTER //
// ./src/components/CRM/DisabledInput.js